import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { API, MediumGroupFullDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-medium-group-proxy',
  templateUrl: './sb-medium-group-proxy.component.html',
  styleUrls: ['./sb-medium-group-proxy.component.scss'],
  standalone: false,
})
export class SbMediumGroupProxyComponent implements OnInit {
  _mediumGroupId: number;
  _companyId: number;
  mediumGroup: MediumGroupFullDTO;
  @Input() time;

  @Input() set mediumGroupId(value: string) {
    this._mediumGroupId = value ? Number(value) : null;
  }

  @Input() set companyId(value: string) {
    this._companyId = value ? Number(value) : null;
  }

  constructor(
    private api: API,
    private errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.getMotiveGroup();
  }

  getMotiveGroup() {
    if (this._mediumGroupId) {
      this.api
        .mm_MediumGroup_retrieveById(this._mediumGroupId)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (group: MediumGroupFullDTO) => {
            this.mediumGroup = group;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
